import { EMPTY_MASTER_CHARGE_QTY_ADJANY_MODEL } from "presentation/model/ChargeQtyAdj/ChargeQtyAdjMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";
const {
    Provider: ChargeQtyAdjMaintenanceProvider,
    useTracked: useChargeQtyAdjMaintenanceTracked
} = createContainer(() => useState(EMPTY_MASTER_CHARGE_QTY_ADJANY_MODEL), { concurrentMode: true });
export { ChargeQtyAdjMaintenanceProvider, useChargeQtyAdjMaintenanceTracked };

